import { render, staticRenderFns } from "./qa-link.vue?vue&type=template&id=4f72f190&scoped=true&"
import script from "./qa-link.vue?vue&type=script&lang=js&"
export * from "./qa-link.vue?vue&type=script&lang=js&"
import style0 from "./qa-link.vue?vue&type=style&index=0&id=4f72f190&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f72f190",
  null
  
)

export default component.exports